<template>
  <el-dialog
    class="dialog-container"
    :title="title"
    :visible.sync="dialogVisible"
    width="900px"
    append-to-body
    top="5vh"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      v-loading="formLoading"
      :inline="true"
      label-position="top"
      :disabled="disabled"
    >
      <el-form-item label="网点名称" prop="outletsName">
        <el-input v-model="form.outletsName" placeholder="请输入" />
      </el-form-item>
      <el-form-item label="店面类别" prop="storefrontType">
        <el-select
          filterable
          clearable
          v-model="form.storefrontType"
          placeholder="请选择"
          style="width:100%"
        >
          <el-option label="直营专营" value="直营专营"></el-option>
          <el-option label="直营综合" value="直营综合"></el-option>
          <el-option label="二级专营" value="二级专营"></el-option>
          <el-option label="二级综合" value="二级综合"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="店面选址说明 (所处位置，周边竞品等)"
        prop="storefrontAddress"
      >
        <el-input v-model="form.storefrontAddress" placeholder="请输入" />
      </el-form-item>
      <el-form-item label="团队构成" prop="teamComposition">
        <el-input v-model="form.teamComposition" placeholder="请输入" />
      </el-form-item>
      <el-form-item
        label="团队能力说明(投资人状态及市场人员能力、销售人员能力说明)"
        prop="teamCapacityRemark"
      >
        <el-input v-model="form.teamCapacityRemark" placeholder="请输入" />
      </el-form-item>
      <el-form-item
        label="投资人投资汇报满意度说明(专营店：利润；综合店：收入、利润占比)"
        prop="investorsSatisfiedRemark"
      >
        <el-input
          v-model="form.investorsSatisfiedRemark"
          placeholder="请输入"
        />
      </el-form-item>
      <el-form-item label="售后服务能力" prop="carModel">
        <el-select
          filterable
          clearable
          v-model="form.afterSaleServiceAbility"
          placeholder="请选择"
          style="width:100%"
        >
          <el-option label="销服一体" value="销服一体"></el-option>
          <el-option label="合作售后服务" value="合作售后服务"></el-option>
          <el-option label="无售后" value="无售后"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="与竞品的销量对标(同一区域的竞品门店销量对比；品牌、车型、销量)"
        prop="competitionSaleBenchmarking"
      >
        <el-input
          v-model="form.competitionSaleBenchmarking"
          placeholder="请输入"
        />
      </el-form-item>
      <el-form-item label="联系电话" prop="phone">
        <el-input v-model="form.phone" placeholder="请输入" />
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="form.remark" placeholder="请输入" />
      </el-form-item>
      <div>
        <el-form-item label="门头" prop="imgDoorHead">
          <upload-img
            action="/manage/saleChannelController/upload/file"
            v-model="form.imgDoorHead"
            :limit="5"
            :disabled="disabled"
          >
            <div>支持jpg、png、jpeg格式图片上传图片不超过5M，数量不超过5张</div>
          </upload-img>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="修理车间" prop="imgRepairWorkshop">
          <upload-img
            action="/manage/saleChannelController/upload/file"
            v-model="form.imgRepairWorkshop"
            :limit="5"
            :disabled="disabled"
          >
            <div>支持jpg、png、jpeg格式图片上传图片不超过5M，数量不超过5张</div>
          </upload-img>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="展厅" prop="imgExhibitionHall">
          <upload-img
            action="/manage/saleChannelController/upload/file"
            v-model="form.imgExhibitionHall"
            :limit="5"
            :disabled="disabled"
          >
            <div>支持jpg、png、jpeg格式图片上传图片不超过5M，数量不超过5张</div>
          </upload-img>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="停车场" prop="imgParking">
          <upload-img
            action="/manage/saleChannelController/upload/file"
            v-model="form.imgParking"
            :limit="5"
            :disabled="disabled"
          >
            <div>支持jpg、png、jpeg格式图片上传图片不超过5M，数量不超过5张</div>
          </upload-img>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="其他" prop="imgOther">
          <upload-img
            action="/manage/saleChannelController/upload/file"
            v-model="form.imgOther"
            :limit="5"
            :disabled="disabled"
          >
            <div>支持jpg、png、jpeg格式图片上传图片不超过5M，数量不超过5张</div>
          </upload-img>
        </el-form-item>
      </div>
    </el-form>
    <div slot="footer" class="text-center" v-if="!disabled">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" :loading="saveLoading" @click="handleSave">
        确定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import UploadImg from "@/components/uploadImg.vue";
import { addOrUpdateChannelInfoApi } from "@/api/saleTaskCollection";

export default {
  components: {
    UploadImg
  },
  data() {
    return {
      title: "",
      dialogVisible: false,
      formLoading: false,
      saveLoading: false,
      form: this.getForm(),
      disabled: false,
      rules: {
        outletsName: [
          { required: true, message: "网点名称不能为空", trigger: "blur" }
        ],
        storefrontType: [
          { required: true, message: "店面类别不能为空", trigger: "change" }
        ]
      }
    };
  },
  mounted() {},
  methods: {
    // 初始化
    async init(title, data) {
      this.title = title;
      if (title === "查看渠道信息") {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
      this.dialogVisible = true;
      this.form = this.getForm(data || {});
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    // 获取表单对象
    getForm(data = {}) {
      return {
        id: data.id || "",
        outletsName: data.outletsName || "", // 网点名称
        storefrontType: data.storefrontType || "", // 店面类别
        storefrontAddress: data.storefrontAddress || "", // 店面选址说明
        teamComposition: data.teamComposition || "", // 团队构成
        teamCapacityRemark: data.teamCapacityRemark || "", // 团队能力说明
        investorsSatisfiedRemark: data.investorsSatisfiedRemark || "", // 投资人投资汇报满意度说明
        afterSaleServiceAbility: data.afterSaleServiceAbility || "", // 售后服务能力
        competitionSaleBenchmarking: data.competitionSaleBenchmarking || "", // 与竞品的销量对标
        phone: data.phone || "", // 联系电话
        remark: data.remark || "", // 备注
        imgDoorHead: data.imgDoorHead ? data.imgDoorHead.split(",") : [], // 门头
        imgRepairWorkshop: data.imgRepairWorkshop
          ? data.imgRepairWorkshop.split(",")
          : [], // 修理车间
        imgExhibitionHall: data.imgExhibitionHall
          ? data.imgExhibitionHall.split(",")
          : [], // 展厅
        imgParking: data.imgParking ? data.imgParking.split(",") : [], // 停车场
        imgOther: data.imgOther ? data.imgOther.split(",") : [] // 其他
      };
    },
    // 保存
    handleSave() {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return;
        }
        this.saveLoading = true;
        try {
          const submitData = JSON.parse(
            JSON.stringify({
              areaName: this.$route.query.areaName,
              countryName: this.$route.query.countryName,
              ...this.form
            })
          );
          submitData.imgDoorHead = submitData.imgDoorHead.join(",");
          submitData.imgRepairWorkshop = submitData.imgRepairWorkshop.join(",");
          submitData.imgExhibitionHall = submitData.imgExhibitionHall.join(",");
          submitData.imgParking = submitData.imgParking.join(",");
          submitData.imgOther = submitData.imgOther.join(",");
          const res = await addOrUpdateChannelInfoApi(submitData);
          if (res.status == 0) {
            this.dialogVisible = false;
            this.$DonMessage.success("操作成功！");
            this.$emit("success");
          } else {
            this.$DonMessage.error(res.message);
          }
        } catch (error) {
          console.error(error);
        }
        this.saveLoading = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-container {
  ::v-deep .el-dialog {
    border-radius: 5px;
    .el-dialog__header {
      height: 47px;
      padding: 0 12px 0 28px;
      border-bottom: 1px solid #efefef;
      border-radius: 5px 5px 0 0;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .el-dialog__title {
        color: #333333;
        font-size: 18px;
      }

      .el-dialog__headerbtn {
        position: unset;
        font-size: 22px;
      }
    }
    .el-dialog__footer {
      text-align: center;
      border-top: 1px solid #efefef;
      padding: 20px 20px 26px 20px;
    }
  }
}
</style>
